export function PaywallBadge({ paywall }: { paywall: boolean }) {
  if (!paywall) {
    return (
      <span className="meta inline-flex items-center gap-1">
        <span aria-hidden>◦</span> fri adgang
      </span>
    );
  }
  return (
    <span className="meta inline-flex items-center gap-1 text-bordeaux" title="Bag betalingsmur">
      <svg width="11" height="12" viewBox="0 0 11 12" fill="none" aria-hidden>
        <path d="M2 5V3.5a3.5 3.5 0 117 0V5" stroke="currentColor" strokeWidth="1" />
        <rect x="1" y="5" width="9" height="6.5" rx="1" stroke="currentColor" strokeWidth="1" fill="none"/>
      </svg>
      betalingsmur
    </span>
  );
}
